var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 50 49.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-close",
    d: "M10604.448-1665.466a5.016,5.016,0,0,1,0-7.055l16.483-16.483-16.483-16.486a5.015,5.015,0,0,1,0-7.055,5,5,0,0,1,7.054,0l16.48,16.486,16.5-16.486a5,5,0,0,1,7.051,0,5.018,5.018,0,0,1,1.453,3.534,4.967,4.967,0,0,1-1.453,3.521L10635.041-1689l16.492,16.483a4.98,4.98,0,0,1,0,7.055,4.982,4.982,0,0,1-3.523,1.46,5,5,0,0,1-3.527-1.46l-16.5-16.486-16.48,16.486a4.941,4.941,0,0,1-3.519,1.464A4.99,4.99,0,0,1,10604.448-1665.466Z",
    transform: "translate(-10602.998 1713.999)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.ebee7ba8411863984762d7ee15ce4325.svg";
export { ForwardRef as ReactComponent };